// TODO: CLOUDWEB-14876 - заменить на новый компонент empty-state'а после аб.
import { Button, Spacing, Text } from '@vkontakte/vkui';
import emptyImg from 'img/empty-state/album.png';
import emptyDarkImg from 'img/empty-state/dark/album.png';
import React, { memo, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { createAlbumRequest } from 'reactApp/modules/albums/albums.actions';
import { ThemeContext } from 'reactApp/modules/theme/theme.context';
import { sendEmptyStatesAnalitics } from 'reactApp/utils/emptyStatesGa';

import styles from './AlbumsEmpty.css';

export const AlbumsEmpty = memo(() => {
    const dispatch = useDispatch();
    const isDark = useContext(ThemeContext).isDark;

    const handleAlbumCreate = useCallback(() => {
        sendEmptyStatesAnalitics({ action: 'album-click' });

        dispatch(createAlbumRequest());
    }, [dispatch]);

    return (
        <div className={styles.root}>
            <img className={styles.image} src={isDark ? emptyDarkImg : emptyImg} alt="Альбомы для фото и видео" />
            <Spacing size={24} />
            <Text className={styles.title}>Пока нет альбомов</Text>
            <Spacing size={12} />
            <Text className={styles.text}>Соберите тематическую коллекцию фото или&nbsp;видео — всё будет здесь</Text>
            <Spacing size={24} />
            <Button className={styles.button} mode="secondary" appearance="neutral" size="m" onClick={handleAlbumCreate}>
                Создать альбом
            </Button>
        </div>
    );
});

AlbumsEmpty.displayName = 'AlbumsEmpty';
